module.exports = __webpack_public_path__ + "static/media/Blue-check.938c79c8.svg";